var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8212 15.1787L24.0002 9.99975C24.5524 9.4476 24.5524 8.55238 24.0002 8.00023C23.4479 7.4479 22.5523 7.44814 22.0002 8.00078L16.8297 13.1768C16.3756 13.6314 15.6389 13.6318 15.1843 13.1777L10.0003 7.99919C9.44775 7.44726 8.55249 7.4475 8.00026 7.99972C7.44783 8.55215 7.44783 9.44782 8.00026 10.0003L13.3628 15.3629C13.7148 15.7148 13.7149 16.2853 13.3632 16.6374L8.00315 22.0032C7.45284 22.5541 7.45224 23.4465 8.00181 23.9981C8.55284 24.5512 9.44811 24.5523 10.0005 24.0005L15.3712 18.6356C15.7226 18.2845 16.292 18.2849 16.643 18.6363L22.0009 23.9998C22.5533 24.5529 23.4489 24.5551 24.0041 24.0049C24.5633 23.4509 24.5647 22.5476 24.0074 21.9917L18.8223 16.8202C18.3683 16.3674 18.3678 15.6321 18.8212 15.1787Z",
    fill: "#0053C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCloseIcon);
export default __webpack_public_path__ + "static/media/x_close_icon.2dc9ae138f328901cfbbf087c373a953.svg";
export { ForwardRef as ReactComponent };